import { PaginationData, PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { Role } from '@/constants/role';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type InvitedUserInfo = {
  id: string;
  email: string;
  bizTargetType: BizTargetType;
  role: Role;
  invitedAt: string;
  isInviting: true;
  name?: string;
  registeredAt: string;
  isLoggedInUser: boolean; // 본인 계정 유무
};

export type InvitedUserList = PaginationData<InvitedUserInfo[]>;

export const getInvitedUserList = (page: number, id: string) => {
  return api<PaginationPcApiResponse<InvitedUserInfo[]>>('get', `/pc-api/v1/${PREFIX_PATH}/user/list/invited`, {
    page,
    id,
    size: 15
  });
};
